import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';

import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';

import { type Socio } from './interfaces/socio.interface';

const setColumn = <K extends keyof Socio>(key: K, header: string, width?: number): CustomColumnDef<Socio> => ({
	accessorKey: key,
	header,
	enableSorting: false,
	...(width ? { th: { width } } : {}),
	responsive: {
		sizeColumn: 'full',
	},
	cell({ getValue }) {
		const value = getValue();
		return <CTNEllipsis content={value?.toString()} />;
	},
});

const COLUMNS_DEFINITION: Array<CustomColumnDef<Socio>> = [
	setColumn('nAsiento', 'ASIENTO', 100),
	setColumn('fecha', 'FECHA', 100),
	setColumn('titular', 'TITULAR INSCRITO'),
	setColumn('nDocumento', 'Nº DOC.', 150),
	setColumn('participacion', 'PARTICIP.', 100),
	setColumn('numeracion', 'NUMERACIÓN', 100),
	setColumn('titulo', 'TÍTULO O CAUSA'),
	setColumn('domicilio', 'Dirección'),
];

const getColumns = (): Array<CustomColumnDef<Socio>> => COLUMNS_DEFINITION;

export { getColumns };